/* ============================================================================
   component-card-08.js
   Extraído de snippets/product-card-08.liquid em 2026-06-23.
   Carregado uma vez via snippets/global-script.liquid com defer (em vez de
   embutido inline em cada instância do card, o que estava custando ~1.3 MB por
   home). Usa delegação de evento em document — funciona para cards injetados
   via ajax (wishlist / quick search) sem precisar re-init.
   ============================================================================ */

(function(){
  if (!window.PistaCard08Initialized) {
    window.PistaCard08Initialized = true;

    const revertToOriginal = function(root) {
        const mainImg = root.querySelector('.pista-image-link > img:first-of-type');
        const cardMediaWrapper = root.querySelector('.card-product__wrapper');
        if (!mainImg || !cardMediaWrapper) return;

        const originalSrc = mainImg.dataset.originalImage;
        const originalIsPng = mainImg.dataset.originalIsPng === 'true';

        if (originalSrc) {
            mainImg.style.transition = 'none';
            mainImg.src = originalSrc;
            
            const hoverImg = root.querySelector('.pista-image-link > img:nth-of-type(2)');
            if (hoverImg) {
                hoverImg.style.display = ''; 
            }

            if (originalIsPng) {
                cardMediaWrapper.classList.remove('is-jpg');
                cardMediaWrapper.classList.add('is-png');
            } else {
                cardMediaWrapper.classList.remove('is-png');
                cardMediaWrapper.classList.add('is-jpg');
            }
            
            /* Limpa a opacidade inline do swatch: se ela ficar, o hover mostra as 2 fotos juntas. */
            mainImg.style.opacity = '';
            setTimeout(() => {
                mainImg.style.transition = '';
            }, 50);
        }
    };

    document.addEventListener('click', function(e) {
      const swatch = e.target.closest('.swatch-color');
      
      if (!swatch) {
          document.querySelectorAll('.swatch-color.active').forEach(activeSwatch => {
              const root = activeSwatch.closest('.product-item');
              activeSwatch.classList.remove('active');
              if (root) revertToOriginal(root);
          });
          return;
      }

      e.preventDefault();
      e.stopPropagation();

      const root = swatch.closest('.product-item');
      if (!root) return;

      if (swatch.classList.contains('active')) {
          swatch.classList.remove('active');
          revertToOriginal(root);
          return;
      }

      const mainImg = root.querySelector('.pista-image-link > img:first-of-type');
      const cardMediaWrapper = root.querySelector('.card-product__wrapper');
      const allSwatches = root.querySelectorAll('.swatch-color');

      allSwatches.forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');

      const newSrc = swatch.dataset.image;
      const hasImage = newSrc && newSrc.indexOf('no-image') === -1;
      
      if(hasImage && mainImg) {
        mainImg.style.transition = 'none';
        mainImg.src = newSrc;
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');

        const hoverImg = root.querySelector('.pista-image-link > img:nth-of-type(2)');
        if(hoverImg) {
            hoverImg.style.display = 'none';
        }

        const isPng = swatch.dataset.imageIsPng === 'true' || newSrc.includes('.png');
        if (isPng) {
            cardMediaWrapper.classList.remove('is-jpg');
            cardMediaWrapper.classList.add('is-png');
        } else {
            cardMediaWrapper.classList.remove('is-png');
            cardMediaWrapper.classList.add('is-jpg');
        }

        mainImg.style.opacity = '1';

        setTimeout(() => {
            mainImg.style.transition = '';
        }, 50);
      }
    });

    /* Segunda foto do card: só baixa com mouse sobre o card. A troca no hover
       (classe has-second-image) só liga depois que a foto termina de carregar,
       para a foto principal não sumir antes. */
    const canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
    document.addEventListener('mouseover', function(e) {
      if (!e.target.closest || document.documentElement.classList.contains('pista-touch')) return;
      if (!canHover || !canHover.matches) return;
      const card = e.target.closest('.pista-card-global');
      const hoverImg = card && card.querySelector('.pista-image-hover[data-src]');
      if (!hoverImg) return;
      hoverImg.addEventListener('load', function() {
        card.classList.add('has-second-image');
      }, { once: true });
      if (hoverImg.dataset.srcset) hoverImg.srcset = hoverImg.dataset.srcset;
      hoverImg.src = hoverImg.dataset.src;
      hoverImg.removeAttribute('data-src');
      hoverImg.removeAttribute('data-srcset');
    });

    document.addEventListener('mouseover', function(e) {
      const swatch = e.target.closest('.swatch-color');
      if (!swatch) return;

      const root = swatch.closest('.product-item');
      if(root) {
          const cardMedia = root.querySelector('.card-product__wrapper');
          if(cardMedia) {
              const link = cardMedia.querySelector('a');
              if(link) link.style.pointerEvents = 'none';
          }
      }
      
      const preloadSrc = swatch.dataset.image;
      if(preloadSrc && preloadSrc.indexOf('no-image') === -1) {
          const imgPreloader = new Image();
          imgPreloader.src = preloadSrc;
      }
    });

    document.addEventListener('mouseout', function(e) {
      const swatch = e.target.closest('.swatch-color');
      if (!swatch) return;

      const root = swatch.closest('.product-item');
      if(root) {
          const cardMedia = root.querySelector('.card-product__wrapper');
          if(cardMedia) {
              const link = cardMedia.querySelector('a');
              if(link) link.style.pointerEvents = 'auto';
          }
      }
    });

    /* ========================================================================
       SKU FLUTUANTE: COPIAR NO CLIQUE (2026-09-24, by🔥Pista)
       A pill fica dentro da imagem do card, mas FORA do <a> do produto, entao
       o clique nao navega. Mesmo assim damos preventDefault/stopPropagation:
       o card inteiro costuma ter handlers de clique por delegacao.
       navigator.clipboard so funciona em https e pode ser bloqueado por
       permissao — por isso o fallback com textarea + execCommand.
       ======================================================================== */
    const copiarTexto = function(texto) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(texto).then(function(){ return true; })
                                                   .catch(function(){ return copiarFallback(texto); });
      }
      return Promise.resolve(copiarFallback(texto));
    };

    const copiarFallback = function(texto) {
      try {
        const ta = document.createElement('textarea');
        ta.value = texto;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.top = '-1000px';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(ta);
        return ok;
      } catch (err) {
        return false;
      }
    };

    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.pista-sku-copy');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const sku = btn.getAttribute('data-pista-sku');
      if (!sku || btn.dataset.pistaSkuBusy === '1') return;

      copiarTexto(sku).then(function(ok) {
        if (!ok) return;

        /* Mesmo feedback da pagina de produto: a opacidade cai e volta
           sozinha depois de 1s. Sem troca de texto, sem balao. */
        btn.dataset.pistaSkuBusy = '1';
        btn.classList.add('is-copying');

        setTimeout(function() {
          btn.classList.remove('is-copying');
          delete btn.dataset.pistaSkuBusy;
        }, 1000);
      });
    });
  }
})();